package com.essntl.features.client.ui.addeditclient

import com.essntl.features.client.domain.model.ClientModel

sealed interface AddEditClientEvent {
    data class UpdateClientFields(
        val client: ClientModel,
    ) : AddEditClientEvent

    data object AddClient : AddEditClientEvent

    data object EditClient : AddEditClientEvent

    data class GetClient(
        val clientId: String,
    ) : AddEditClientEvent

    data class GetClientByPhoneNumber(
        val phoneNumber: String,
    ) : AddEditClientEvent

    data object ClearSuccessState : AddEditClientEvent
    data object ClearClientState : AddEditClientEvent
}